define('apps/admin/views/modals/leave-service-data-details-form-modal',[
    'app',
    'njs!apps/admin/templates/includes/modals/_leave_service_data_details_form_modal(params:tmpl=admin/main/includes/modals/_leave_service_data_details_form_modal.html)',
], function (app, template) {
    'use strict';

    return Mn.ItemView.extend({

        "events": {
            "click .comet-modal__button--cancel": "closeModal",
            "click .comet-modal-overlay--backdrop": "closeModal",
            "click .comet-modal__button--confirm": "closeModal",
        },

        "template": template,

        "initialize": function (opts) {
            this.model.set({
                "showCancelButton": true,
                "showOKButton": false
            });
        },

        "closeModal": function (event) {
            this.destroy();
        },
    });
});

